import { useGetPayableByPayoutRequestId } from "@fp/admin-api-client/payouts/payouts.client";
import { PageLoading } from "@fp/ui/components/base/page-layout/page-layout";
import { createFileRoute, useNavigate, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { AdminLayout } from "@/components/admin-layout";

export const Route = createFileRoute("/payout-requests/direct/$id")({
  component: RouteComponent,
  pendingComponent: () => <PageLoading />,
});

/**
 * A direct payout request is settled by the payout a staff member created and is reviewed
 * there. The request does not know its payout. The payable that contains it is read and
 * this screen is replaced by it. The list's return state is carried across so back still
 * leads to the list the request was opened from.
 */
function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const locationState = useRouterState({ select: (state) => state.location.state });
  const { data, isError } = useGetPayableByPayoutRequestId(id);

  const payoutId = data?.data.id;

  useEffect(() => {
    if (payoutId) {
      navigate({ to: "/payouts/$payoutId", params: { payoutId }, state: locationState, replace: true });
    }
  }, [payoutId, locationState, navigate]);

  useEffect(() => {
    if (isError) {
      navigate({ to: "/payout-requests", replace: true });
    }
  }, [isError, navigate]);

  return (
    <AdminLayout>
      <PageLoading />
    </AdminLayout>
  );
}